import React from 'react'
import { styled, useTheme } from '@mui/material'

const MainContainer = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.palette.grey.grey06,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))

interface Props {
  image: React.ReactElement
  suffix?: React.ReactNode
  disabled?: boolean
  depth?: number
  className?: string
}

/**
 * Shows the active contract in the vdpp settings
 */
const ActiveContractCard: React.FC<Props> = ({ image, suffix, disabled = false, depth = 0, ...rest }) => {
  const theme = useTheme()
  const backgroundColorEnabled = depth % 2 === 0 ? theme.palette.grey.grey07 : theme.palette.background.paper

  return (
    <MainContainer {...rest} sx={{ backgroundColor: disabled ? theme.palette.grey.grey06 : backgroundColorEnabled }}>
      {image}
      {suffix}
    </MainContainer>
  )
}

export default ActiveContractCard
